App.controller('ResponseResponseAnswerCtrl', ResponseResponseAnswerCtrl);

ResponseResponseAnswerCtrl.$inject = [
    '$routeParams',
    'summary',
    'answers'
];

function ResponseResponseAnswerCtrl($routeParams, summary, answers) {
    var vm = this;

    vm.summary = summary;
    vm.answers = answers;
    vm.code = $routeParams.code;
    vm.id = $routeParams.id;
}
